import React from 'react';
import styled from 'styled-components';

import { Container } from '../projectSet/Project';
import { Discription } from '../Introduction';


const LineView = styled.div`
position: absolute;

    margin-top: ${window.innerHeight / 1.7}px;
    left: 50%;
    transform: translateX(-50%);
    width: ${window.innerWidth / 2}px; /* 가로 길이 조정 */
    height: 2px; /* 선의 두께 */
    background-color: rgba(0, 92, 249); /* 선의 색상 */
`;

const MobileIntroduction = () => {
    return (
        <Container>
            <img src={'images/jaejungNameImage.png'} style={{ width: '100%' }}></img>
            <LineView/>
            
            <Discription style={{ fontSize:'120%' }}>FRONTEND DEVELOP</Discription>
        </Container>
    );
};

export default MobileIntroduction;
